import PagedResponse from "@/types/sv-data/PagedResponse";
import { PaginatedQueryParams } from "../types";

export interface Label {
	labelId: number;
	labelTypeId: number;
	title: string;
	labelTypeTitle: string;
	groupId: number;
	groupTitle: string;
}

export interface LabelType {
	labelTypeId: number,
	title: string
}

export interface LabelPagedResonse extends PagedResponse {
	data: Label[];
}

export enum LabelTypes {
	ActionPlan = 1,
}

export const LabelTypesForDisplay: LabelType[] = [
	{
		labelTypeId: LabelTypes.ActionPlan,
		title: "Action Plan"
	}
];
export interface LabelTypeQueryParams extends PaginatedQueryParams {
	labelTypeId?: number;
}